import { Typography } from '@mui/material';

import {
  selectScenarioDaysOfWeekInfo,
  selectScenarioEnd,
  selectScenarioName,
  selectScenarioStart,
} from 'state/detourSlices';
import { useAppSelector } from 'state/hooks';
import { selectCurrentScenarioId } from 'state/workflowSlice';

import { useRouteProperties } from 'features/common/hooks/useRouteProperties';

import { formatClosureDurationLabel } from '../utils';

import styles from '../../map/Map.module.css';
import routeStyles from 'features/workflow_routemonitoring/RouteRow.module.css';

export function DetourClosureHoverTooltip() {
  const scenarioName = useAppSelector(selectScenarioName);
  const currentScenarioId = useAppSelector(selectCurrentScenarioId);
  const closureStart = useAppSelector(selectScenarioStart);
  const closureEnd = useAppSelector(selectScenarioEnd);
  const { startDay, endDay } = useAppSelector(selectScenarioDaysOfWeekInfo);
  const routeProperties = useRouteProperties();

  const name =
    (currentScenarioId && scenarioName) || routeProperties?.name || undefined;
  const duration = formatClosureDurationLabel(
    closureStart,
    closureEnd,
    startDay,
    endDay,
  );

  if (!name && !duration) return null;

  return (
    <div
      className={styles.map_tooltip_container}
      id={styles.map_tooltip_closure}
      data-hide-in-export
    >
      {name && <Typography variant="body2">{name}</Typography>}
      {duration && (
        <Typography variant="caption" className={routeStyles.route_signature}>
          {duration}
        </Typography>
      )}
    </div>
  );
}
